import { camelCase } from 'lib/utils/objectSerializer';
import format from '../orders/formatter';

export const initialState = {
  branchId: undefined,
  startDate: undefined,
  endDate: undefined,
  refundStatus: '',
  refundedOrders: [],
  totalRefundedOrders: undefined,
  refundedOrdersById: {},
  timezone: undefined,
  rollingStatistics: [],
  summary: undefined,
  singleRefundedOrder: undefined,
  detailError: undefined,

  listLoading: false,
  summaryLoading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_REFUNDED_ORDERS_REQUEST':
    case 'GET_MORE_REFUNDED_ORDERS_REQUEST': {
      return {
        ...state,
        listLoading: true,
      };
    }

    case 'GET_REFUNDED_ORDERS_FAILURE':
    case 'GET_MORE_REFUNDED_ORDERS_FAILURE': {
      return {
        ...state,
        listLoading: false,
        listError: {
          status: action.status,
          message: action.payload.error,
        },
      };
    }

    case 'GET_REFUNDED_ORDERS_SUCCESS':
    case 'GET_MORE_REFUNDED_ORDERS_SUCCESS': {
      const refundedOrders = action.payload.refunded_orders;
      const totalRefundedOrders = action.payload.total_orders;
      const { branchId, startDate, endDate, refundStatus } = action.extra;
      const shouldReplace =
        branchId !== state.branchId ||
        startDate !== state.startDate ||
        endDate !== state.endDate ||
        refundStatus !== state.refundStatus ||
        action.type === 'GET_REFUNDED_ORDERS_SUCCESS';
      return {
        ...state,
        branchId,
        startDate,
        endDate,
        totalRefundedOrders,
        refundedOrders: shouldReplace
          ? refundedOrders
          : state.refundedOrders.concat(refundedOrders),
        listLoading: false,
        listError: undefined,
        refundStatus,
      };
    }

    case 'GET_REFUND_SUMMARY_STATISTICS_REQUEST': {
      return {
        ...state,
        summaryLoading: true,
        summaryError: undefined,
      };
    }

    case 'GET_REFUND_SUMMARY_STATISTICS_FAILURE': {
      return {
        ...state,
        summaryLoading: false,
        summaryError: camelCase(action.payload),
      };
    }

    case 'GET_REFUND_SUMMARY_STATISTICS_SUCCESS': {
      return {
        ...state,
        summaryLoading: false,
        summary: camelCase(action.payload),
      };
    }

    case 'GET_REFUNDED_ORDER_DETAILS_REQUEST': {
      return {
        ...state,
        detailLoading: true,
        detailError: undefined,
      };
    }

    case 'GET_REFUNDED_ORDER_DETAILS_SUCCESS': {
      const order = format.order(action.payload);

      return {
        ...state,
        detailLoading: false,
        detailError: undefined,
        singleRefundedOrder: order,
        /* refundedOrdersById: {
          ...state.refunds.refundedOrdersById,
          [order.id]: {
            ...order,
          },
        }, */
      };
    }

    case 'GET_REFUNDED_ORDER_DETAILS_FAILURE': {
      return {
        ...state,
        detailLoading: false,
        singleRefundedOrder: undefined,
        detailError: {
          status: action.status,
          message: action.payload.error,
        },
      };
    }

    case 'GET_ROLLING_STATISTICS_REQUEST': {
      return {
        ...state,
        isLoading: true,
      };
    }

    case 'GET_ROLLING_STATISTICS_FAILURE': {
      return {
        ...state,
        isLoading: false,
      };
    }

    case 'GET_ROLLING_STATISTICS_SUCCESS': {
      const rollingStatistics = action.payload;
      const { timezone, startDate, endDate, restaurantIds } = action.extra;

      return {
        ...state,
        timezone,
        startDate,
        endDate,
        restaurantIds,
        rollingStatistics,
        isLoading: false,
      };
    }

    case 'RESET_REFUNDED_ORDER_DETAILS': {
      return {
        ...state,
        singleRefundedOrder: undefined,
      };
    }

    default:
      return state;
  }
};
